(function () {
  'use strict';

  if (window.__orliCommerceEnhancementsLoaded) return;
  window.__orliCommerceEnhancementsLoaded = true;

  var QUOTE_STORAGE_KEY = 'orli:shipping:quote:v1';
  var PENDING_STORAGE_KEY = 'orli:shipping:pending:v1';
  var DEFAULT_QUOTE_MAX_AGE = 30 * 60 * 1000;
  var ASYNC_RATE_MAX_ATTEMPTS = 18;
  var ASYNC_RATE_DELAY = 650;
  var cleanupPromise = null;
  var shippingConfig = window.OrliShippingConfig || {};
  var SHIPPING_MODE = ['disabled', 'free', 'shopify'].indexOf(shippingConfig.mode) !== -1
    ? shippingConfig.mode
    : 'shopify';
  var SHIPPING_QUOTES_ENABLED = SHIPPING_MODE === 'shopify';

  function getRoot() {
    var root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
    return root.endsWith('/') ? root : root + '/';
  }

  function sleep(milliseconds) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, milliseconds);
    });
  }

  function normalizePostalCode(value) {
    return String(value || '').replace(/\D/g, '').slice(0, 8);
  }

  function formatPostalCode(value) {
    var digits = normalizePostalCode(value);
    return digits.length > 5 ? digits.slice(0, 5) + '-' + digits.slice(5) : digits;
  }

  function escapeHTML(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function highlightFreeShipping(value) {
    return escapeHTML(value).replace(
      /frete\s+grátis/gi,
      '<span class="orli-free-shipping-notice__highlight">$&</span>'
    );
  }

  function parsePrice(value) {
    if (typeof value === 'number') return value;

    var normalized = String(value || '')
      .replace(/[^\d,.-]/g, '')
      .replace(/\.(?=\d{3}(?:\D|$))/g, '')
      .replace(',', '.');
    var parsed = Number(normalized);

    return Number.isFinite(parsed) ? parsed : 0;
  }

  function formatMoneyFromDecimal(value, currency) {
    var amount = parsePrice(value);

    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'pt-BR', {
        style: 'currency',
        currency: currency || 'BRL'
      }).format(amount);
    } catch (error) {
      return 'R$ ' + amount.toFixed(2).replace('.', ',');
    }
  }

  function formatMoneyFromCents(value, currency) {
    return formatMoneyFromDecimal(Number(value || 0) / 100, currency);
  }

  function getRateName(rate) {
    return String(rate.presentment_name || rate.name || rate.title || 'Entrega').trim();
  }

  function formatDate(value) {
    if (!value) return '';

    var date = new Date(String(value).length === 10 ? value + 'T12:00:00' : value);
    if (Number.isNaN(date.getTime())) return '';

    return date.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit'
    });
  }

  function getRateDeadline(rate) {
    if (rate.delivery_date) {
      var exactDate = formatDate(rate.delivery_date);
      if (exactDate) return 'Previsão de entrega: ' + exactDate;
    }

    var range = rate.delivery_range || {};
    var minimumDate = formatDate(range.minimum || range.min || rate.min_delivery_date);
    var maximumDate = formatDate(range.maximum || range.max || rate.max_delivery_date);

    if (minimumDate && maximumDate && minimumDate !== maximumDate) {
      return 'Previsão: ' + minimumDate + ' a ' + maximumDate;
    }

    if (maximumDate || minimumDate) {
      return 'Previsão de entrega: ' + (maximumDate || minimumDate);
    }

    if (rate.delivery_days != null) {
      var days = Number(rate.delivery_days);
      if (Number.isFinite(days)) return 'Entrega em até ' + days + (days === 1 ? ' dia útil' : ' dias úteis');
    }

    return '';
  }

  function normalizeRate(rate, fallbackCurrency) {
    var currency = rate.currency || fallbackCurrency || 'BRL';
    var decimalPrice = parsePrice(rate.price);

    return {
      name: getRateName(rate),
      price: decimalPrice,
      priceCents: Math.max(0, Math.round(decimalPrice * 100)),
      priceLabel: decimalPrice === 0 ? 'Grátis' : formatMoneyFromDecimal(decimalPrice, currency),
      currency: currency,
      deadline: getRateDeadline(rate),
      source: rate.source || ''
    };
  }

  function getStoredJSON(storage, key) {
    try {
      var raw = storage.getItem(key);
      return raw ? JSON.parse(raw) : null;
    } catch (error) {
      return null;
    }
  }

  function setStoredJSON(storage, key, value) {
    try {
      storage.setItem(key, JSON.stringify(value));
      return true;
    } catch (error) {
      return false;
    }
  }

  function removeStored(storage, key) {
    try {
      storage.removeItem(key);
    } catch (error) {}
  }

  function getPendingTokens() {
    var tokens = getStoredJSON(window.sessionStorage, PENDING_STORAGE_KEY);
    return Array.isArray(tokens) ? tokens.filter(Boolean) : [];
  }

  function addPendingToken(token) {
    var tokens = getPendingTokens();
    if (tokens.indexOf(token) === -1) tokens.push(token);
    setStoredJSON(window.sessionStorage, PENDING_STORAGE_KEY, tokens);
  }

  function removePendingToken(token) {
    var tokens = getPendingTokens().filter(function (item) {
      return item !== token;
    });

    if (tokens.length) {
      setStoredJSON(window.sessionStorage, PENDING_STORAGE_KEY, tokens);
    } else {
      removeStored(window.sessionStorage, PENDING_STORAGE_KEY);
    }
  }

  function getLineQuoteToken(item) {
    var properties = item && item.properties;
    return properties && properties._orli_shipping_quote ? String(properties._orli_shipping_quote) : '';
  }

  function getCartSignature(cart, extraVariantId, extraQuantity) {
    var quantities = {};

    (cart && Array.isArray(cart.items) ? cart.items : []).forEach(function (item) {
      if (!item || item.requires_shipping === false || getLineQuoteToken(item)) return;

      var variantId = String(item.variant_id || item.id || '');
      if (!variantId) return;

      quantities[variantId] = (quantities[variantId] || 0) + Math.max(0, Number(item.quantity) || 0);
    });

    if (extraVariantId) {
      var safeVariantId = String(extraVariantId);
      quantities[safeVariantId] =
        (quantities[safeVariantId] || 0) + Math.max(1, Number(extraQuantity) || 1);
    }

    return Object.keys(quantities)
      .filter(function (variantId) {
        return quantities[variantId] > 0;
      })
      .sort()
      .map(function (variantId) {
        return variantId + ':' + quantities[variantId];
      })
      .join('|');
  }

  function getQuoteCartState(quote, cart) {
    if (!quote || !quote.cartSignature) return 'invalid';

    var currentSignature = getCartSignature(cart);
    if (currentSignature === quote.cartSignature) return 'applied';

    if (
      quote.context === 'product' &&
      typeof quote.baseCartSignature === 'string' &&
      currentSignature === quote.baseCartSignature
    ) {
      return 'pending';
    }

    return 'invalid';
  }

  async function fetchCart() {
    var response = await fetch(getRoot() + 'cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });

    if (!response.ok) throw new Error('Não foi possível consultar o carrinho.');
    return response.json();
  }

  async function removeTemporaryLines(tokens) {
    var safeTokens = Array.isArray(tokens) ? tokens.filter(Boolean) : [];
    if (!safeTokens.length) return;

    var cart = await fetchCart();
    var matchingItems = cart.items.filter(function (item) {
      return safeTokens.indexOf(getLineQuoteToken(item)) !== -1;
    });

    for (var index = 0; index < matchingItems.length; index += 1) {
      var response = await fetch(getRoot() + 'cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: matchingItems[index].key,
          quantity: 0
        })
      });

      if (!response.ok) throw new Error('Não foi possível restaurar o carrinho após a simulação.');
    }

    safeTokens.forEach(removePendingToken);
  }

  function cleanupPendingShippingItems() {
    if (cleanupPromise) return cleanupPromise;

    var tokens = getPendingTokens();
    if (!tokens.length) return Promise.resolve();

    cleanupPromise = removeTemporaryLines(tokens)
      .catch(function () {})
      .finally(function () {
        cleanupPromise = null;
      });

    return cleanupPromise;
  }

  async function addTemporaryLine(variantId, quantity, token) {
    var response = await fetch(getRoot() + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: [
          {
            id: Number(variantId),
            quantity: Math.max(1, Number(quantity) || 1),
            properties: {
              _orli_shipping_quote: token
            }
          }
        ]
      })
    });

    var payload = await response.json().catch(function () {
      return {};
    });

    if (!response.ok) {
      throw new Error(payload.description || payload.message || 'Não foi possível simular este produto no carrinho.');
    }

    return payload;
  }

  function buildShippingAddressQuery(postalCode) {
    var params = new URLSearchParams();
    params.set('shipping_address[zip]', postalCode);
    params.set('shipping_address[country]', 'Brazil');
    return params.toString();
  }

  async function prepareShippingRates(postalCode) {
    var response = await fetch(getRoot() + 'cart/prepare_shipping_rates.json?' + buildShippingAddressQuery(postalCode), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    });

    if (response.ok || response.status === 202) return;

    var payload = await response.json().catch(function () {
      return null;
    });
    var details = payload && (payload.error || payload.errors);
    var message = Array.isArray(details) ? details.join(' ') : details;

    throw new Error(typeof message === 'string' ? message : 'Não foi possível calcular o frete para este CEP.');
  }

  async function pollShippingRates(postalCode) {
    var endpoint = getRoot() + 'cart/async_shipping_rates.json?' + buildShippingAddressQuery(postalCode);

    for (var attempt = 0; attempt < ASYNC_RATE_MAX_ATTEMPTS; attempt += 1) {
      var response = await fetch(endpoint, {
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      var text = await response.text();

      if (response.ok && text && text !== 'null') {
        var payload;

        try {
          payload = JSON.parse(text);
        } catch (error) {
          throw new Error('A Shopify retornou uma resposta inválida para o cálculo do frete.');
        }

        return Array.isArray(payload.shipping_rates) ? payload.shipping_rates : [];
      }

      if (!response.ok && response.status !== 202) {
        var errorPayload;

        try {
          errorPayload = text ? JSON.parse(text) : null;
        } catch (error) {
          errorPayload = null;
        }

        var details = errorPayload && (errorPayload.error || errorPayload.errors || errorPayload.description);
        var detailList =
          details && typeof details === 'object'
            ? Object.keys(details).reduce(function (messages, key) {
                var value = details[key];
                return messages.concat(Array.isArray(value) ? value : [value]);
              }, [])
            : [details];
        var message = detailList
          .filter(Boolean)
          .map(String)
          .join(' ');

        throw new Error(message || 'Não foi possível carregar as opções de entrega.');
      }

      await sleep(ASYNC_RATE_DELAY);
    }

    throw new Error('O cálculo está demorando mais que o esperado. Tente novamente em alguns instantes.');
  }

  function createToken() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }

    return Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
  }

  function saveQuote(quote) {
    setStoredJSON(window.localStorage, QUOTE_STORAGE_KEY, quote);
    document.dispatchEvent(new CustomEvent('orli:shipping-quote:updated', { detail: quote }));
  }

  function getQuote() {
    var quote = getStoredJSON(window.localStorage, QUOTE_STORAGE_KEY);
    if (!quote || !quote.savedAt) return null;

    var maxAge = Number(quote.maxAge || DEFAULT_QUOTE_MAX_AGE);
    if (Date.now() - Number(quote.savedAt) > maxAge) {
      clearQuote();
      return null;
    }

    return quote;
  }

  function clearQuote() {
    removeStored(window.localStorage, QUOTE_STORAGE_KEY);
    document.dispatchEvent(new CustomEvent('orli:shipping-quote:cleared'));
  }

  function getFriendlyError(error) {
    var message = String(error && error.message ? error.message : '');

    if (/CEP|postal|zip|endereço|address/i.test(message)) {
      return 'Confira o CEP informado e tente novamente.';
    }

    if (/estoque|stock|available|inventory|simular este produto/i.test(message)) {
      return 'Não foi possível simular a variante selecionada. Verifique a disponibilidade do produto.';
    }

    if (/restaurar o carrinho/i.test(message)) {
      return 'A simulação foi interrompida. Atualize a página antes de continuar a compra.';
    }

    return message || 'Não foi possível calcular o frete agora. Tente novamente.';
  }

  class OrliShippingCalculator extends HTMLElement {
    connectedCallback() {
      if (this._connected) return;
      this._connected = true;
      this.form = this.querySelector('[data-orli-shipping-form]');
      this.input = this.querySelector('[data-orli-shipping-zip]');
      this.button = this.querySelector('[data-orli-shipping-submit]');
      this.buttonLabel = this.querySelector('[data-orli-shipping-button-label]');
      this.loader = this.querySelector('[data-orli-shipping-loader]');
      this.feedback = this.querySelector('[data-orli-shipping-feedback]');
      this.currency = this.dataset.currency || 'BRL';
      this.context = this.dataset.context === 'cart' ? 'cart' : 'product';
      this.cartChangedDuringQuote = false;
      this.onSubmit = this.onSubmit.bind(this);
      this.onInput = this.onInput.bind(this);
      this.onCartChange = this.onCartChange.bind(this);
      this.onQuoteChange = this.syncVisibility.bind(this);

      this.form.addEventListener('submit', this.onSubmit);
      this.input.addEventListener('input', this.onInput);
      document.documentElement.addEventListener('cart:change', this.onCartChange);
      document.addEventListener('orli:shipping-quote:updated', this.onQuoteChange);
      document.addEventListener('orli:shipping-quote:cleared', this.onQuoteChange);

      var storedQuote = getQuote();
      if (storedQuote && storedQuote.postalCode) {
        this.input.value = formatPostalCode(storedQuote.postalCode);
      }

      this.syncVisibility();
      cleanupPendingShippingItems();
    }

    disconnectedCallback() {
      if (!this._connected) return;
      this.form.removeEventListener('submit', this.onSubmit);
      this.input.removeEventListener('input', this.onInput);
      document.documentElement.removeEventListener('cart:change', this.onCartChange);
      document.removeEventListener('orli:shipping-quote:updated', this.onQuoteChange);
      document.removeEventListener('orli:shipping-quote:cleared', this.onQuoteChange);
      this._connected = false;
    }

    syncVisibility() {
      if (this.context !== 'cart') return;

      var quote = getQuote();
      if (!quote) {
        this.hidden = false;
        return;
      }

      fetchCart()
        .then(
          function (cart) {
            if (!this._connected) return;
            this.hidden = getQuoteCartState(getQuote(), cart) === 'applied';
          }.bind(this)
        )
        .catch(
          function () {
            if (this._connected) this.hidden = false;
          }.bind(this)
        );
    }

    onInput() {
      this.input.value = formatPostalCode(this.input.value);
      this.input.removeAttribute('aria-invalid');
    }

    onCartChange() {
      if (this.isBusy) this.cartChangedDuringQuote = true;
      if (this.context === 'cart') this.syncVisibility();
    }

    getProductSelection() {
      var formId = this.dataset.productFormId;
      var productForm = formId ? document.getElementById(formId) : null;
      var variantInput = productForm ? productForm.querySelector('[name="id"]') : null;
      var quantityInput = productForm ? productForm.querySelector('[name="quantity"]') : null;

      return {
        variantId: variantInput ? variantInput.value : '',
        quantity: quantityInput ? Math.max(1, Number(quantityInput.value) || 1) : 1
      };
    }

    setBusy(isBusy) {
      this.isBusy = isBusy;
      this.button.disabled = isBusy;
      this.button.setAttribute('aria-busy', isBusy ? 'true' : 'false');
      this.buttonLabel.hidden = isBusy;
      this.loader.hidden = !isBusy;
    }

    showError(message) {
      this.feedback.hidden = false;
      this.feedback.innerHTML =
        '<p class="orli-shipping-calculator__message orli-shipping-calculator__message--error">' +
        escapeHTML(message) +
        '</p>';
    }

    showRates(postalCode, rates) {
      var items = rates
        .map(function (rate) {
          var deadline = rate.deadline
            ? '<span class="orli-shipping-calculator__rate-deadline">' + escapeHTML(rate.deadline) + '</span>'
            : '';

          return (
            '<li class="orli-shipping-calculator__rate">' +
            '<span><span class="orli-shipping-calculator__rate-name">' +
            escapeHTML(rate.name) +
            '</span>' +
            deadline +
            '</span>' +
            '<strong class="orli-shipping-calculator__rate-price">' +
            escapeHTML(rate.priceLabel) +
            '</strong>' +
            '</li>'
          );
        })
        .join('');

      this.feedback.hidden = false;
      this.feedback.innerHTML =
        '<div class="orli-shipping-calculator__destination">' +
        '<span>Opções para o CEP <strong>' +
        escapeHTML(formatPostalCode(postalCode)) +
        '</strong></span>' +
        '</div>' +
        '<ul class="orli-shipping-calculator__rates" role="list">' +
        items +
        '</ul>';
    }

    async onSubmit(event) {
      event.preventDefault();
      if (this.isBusy) return;

      var postalCode = normalizePostalCode(this.input.value);
      if (postalCode.length !== 8) {
        this.input.setAttribute('aria-invalid', 'true');
        this.showError('Digite um CEP válido com 8 números.');
        this.input.focus();
        return;
      }

      var selection = this.context === 'product' ? this.getProductSelection() : null;
      if (this.context === 'product' && !selection.variantId) {
        this.showError('Selecione uma variante disponível antes de calcular o frete.');
        return;
      }

      var token = this.context === 'product' ? createToken() : '';
      var rawRates = [];
      this.cartChangedDuringQuote = false;
      this.feedback.hidden = true;
      this.setBusy(true);

      try {
        await cleanupPendingShippingItems();

        var cartBeforeQuote = await fetchCart();
        var baseCartSignature = getCartSignature(cartBeforeQuote);
        var cartSignature = getCartSignature(
          cartBeforeQuote,
          selection && selection.variantId,
          selection && selection.quantity
        );

        if (!cartSignature) {
          throw new Error('Seu carrinho não possui produtos que precisam de entrega.');
        }

        if (this.context === 'product') {
          addPendingToken(token);
          await addTemporaryLine(selection.variantId, selection.quantity, token);
        }

        await prepareShippingRates(postalCode);
        rawRates = await pollShippingRates(postalCode);

        if (this.cartChangedDuringQuote) {
          throw new Error('O carrinho mudou durante o cálculo. Calcule novamente para atualizar os valores.');
        }

        var normalizedRates = rawRates
          .map(
            function (rate) {
              return normalizeRate(rate, this.currency);
            }.bind(this)
          )
          .sort(function (first, second) {
            return first.price - second.price;
          });

        if (!normalizedRates.length) {
          throw new Error('Não encontramos opções de entrega para este CEP.');
        }

        var maxAgeMinutes = Math.max(5, Number(this.dataset.storageMinutes) || 30);
        var quote = {
          postalCode: postalCode,
          selectedRate: normalizedRates[0],
          rates: normalizedRates,
          variantId: selection ? String(selection.variantId) : '',
          quantity: selection ? selection.quantity : 0,
          context: this.context,
          baseCartSignature: baseCartSignature,
          cartSignature: cartSignature,
          currency: this.currency,
          savedAt: Date.now(),
          maxAge: maxAgeMinutes * 60 * 1000
        };

        saveQuote(quote);
        this.showRates(postalCode, normalizedRates);
      } catch (error) {
        this.showError(getFriendlyError(error));
      } finally {
        if (token) {
          try {
            await removeTemporaryLines([token]);
          } catch (cleanupError) {
            this.showError(getFriendlyError(cleanupError));
          }
        }

        this.setBusy(false);
      }
    }
  }

  class OrliFreeShippingNotice extends HTMLElement {
    connectedCallback() {
      if (this._connected) return;
      this._connected = true;
      this.titleElement = this.querySelector('[data-orli-free-shipping-title]');
      this.fixedFree = this.dataset.fixedFree === 'true' || !SHIPPING_QUOTES_ENABLED;
      this.onCartChange = this.onCartChange.bind(this);
      document.documentElement.addEventListener('cart:change', this.onCartChange);

      if (this.fixedFree) {
        this.render({
          total_price: 0,
          currency: this.dataset.currency || 'BRL'
        });
      } else {
        this.refresh();
      }
    }

    disconnectedCallback() {
      document.documentElement.removeEventListener('cart:change', this.onCartChange);
      this._connected = false;
    }

    onCartChange(event) {
      var cart = event && event.detail && event.detail.cart;
      if (cart) {
        this.render(cart);
      } else if (this.fixedFree) {
        this.render({
          total_price: 0,
          currency: this.dataset.currency || 'BRL'
        });
      } else {
        this.refresh();
      }
    }

    refresh() {
      if (this.fixedFree) {
        this.render({
          total_price: 0,
          currency: this.dataset.currency || 'BRL'
        });
        return;
      }

      fetchCart()
        .then(
          function (cart) {
            this.render(cart);
          }.bind(this)
        )
        .catch(function () {});
    }

    render(cart) {
      var threshold = Math.max(0, Number(this.dataset.thresholdCents) || 0);
      var total = Math.max(0, Number(cart && cart.total_price) || 0);
      var currency = (cart && cart.currency) || this.dataset.currency || 'BRL';
      var qualifies = threshold === 0 || total >= threshold;
      var progress = threshold === 0 ? 100 : Math.min(100, (total / threshold) * 100);
      var message = '';

      if (qualifies) {
        message = this.dataset.successText;
      } else if (total > 0) {
        message = this.dataset.remainingText.replace('[amount]', formatMoneyFromCents(threshold - total, currency));
      } else {
        message = this.dataset.emptyText.replace('[amount]', formatMoneyFromCents(threshold, currency));
      }

      this.classList.toggle('is-success', qualifies);
      this.style.setProperty('--orli-free-shipping-progress', progress + '%');
      if (this.titleElement) this.titleElement.innerHTML = highlightFreeShipping(message);
    }
  }

  class OrliCartTotals extends HTMLElement {
    connectedCallback() {
      if (this._connected) return;
      this._connected = true;
      this.shippingMode = this.dataset.shippingMode || SHIPPING_MODE;
      this.usesShopifyRates = this.shippingMode === 'shopify' && SHIPPING_QUOTES_ENABLED;
      this.productsValue = this.querySelector('[data-orli-cart-products-value]');
      this.shippingRow = this.querySelector('[data-orli-cart-shipping-row]');
      this.shippingValue = this.querySelector('[data-orli-cart-shipping-value]');
      this.shippingDetail = this.querySelector('[data-orli-cart-shipping-detail]');
      this.totalValue = this.querySelector('[data-orli-cart-total-value]');
      this.installmentValue = this.querySelector('[data-orli-cart-installment-value]');
      this.onQuoteChange = this.refresh.bind(this);
      this.onCartChange = this.handleCartChange.bind(this);
      this.onClick = this.handleClick.bind(this);

      if (this.usesShopifyRates) {
        document.addEventListener('orli:shipping-quote:updated', this.onQuoteChange);
        document.addEventListener('orli:shipping-quote:cleared', this.onQuoteChange);
      }
      document.documentElement.addEventListener('cart:change', this.onCartChange);
      this.addEventListener('click', this.onClick);
      this.refresh();
    }

    disconnectedCallback() {
      if (this.usesShopifyRates) {
        document.removeEventListener('orli:shipping-quote:updated', this.onQuoteChange);
        document.removeEventListener('orli:shipping-quote:cleared', this.onQuoteChange);
      }
      document.documentElement.removeEventListener('cart:change', this.onCartChange);
      this.removeEventListener('click', this.onClick);
      this._connected = false;
    }

    handleClick(event) {
      if (!this.usesShopifyRates) return;
      if (!event.target.closest('[data-orli-shipping-quote-reset]')) return;
      event.preventDefault();
      clearQuote();
    }

    handleCartChange(event) {
      var cart = event && event.detail && event.detail.cart;

      if (cart && Array.isArray(cart.items)) {
        this.render(cart);
      } else {
        this.refresh();
      }
    }

    refresh() {
      if (!this.usesShopifyRates) {
        this.render({
          total_price: Number(this.dataset.cartTotalCents) || 0,
          currency: this.dataset.currency || 'BRL',
          items: []
        });
        return;
      }

      fetchCart()
        .then(
          function (cart) {
            this.render(cart);
          }.bind(this)
        )
        .catch(
          function () {
            this.render({
              total_price: Number(this.dataset.cartTotalCents) || 0,
              currency: this.dataset.currency || 'BRL',
              items: []
            });
          }.bind(this)
        );
    }

    render(cart) {
      var productTotal = Math.max(0, Number(cart && cart.total_price) || 0);
      var currency = (cart && cart.currency) || this.dataset.currency || 'BRL';

      this.dataset.cartTotalCents = String(productTotal);
      this.dataset.currency = currency;

      if (!this.usesShopifyRates) {
        if (this.productsValue) this.productsValue.textContent = formatMoneyFromCents(productTotal, currency);
        if (this.shippingRow) {
          this.shippingRow.hidden = false;
          this.shippingRow.classList.add('is-free');
        }
        if (this.shippingValue) this.shippingValue.textContent = 'Grátis';
        if (this.shippingDetail) this.shippingDetail.textContent = '';
        if (this.totalValue) this.totalValue.textContent = formatMoneyFromCents(productTotal, currency);

        if (this.installmentValue) {
          var fixedInstallments = Math.max(1, Number(this.dataset.installments) || 1);
          var fixedInterestFactor = Math.max(0, Number(this.dataset.interestFactor) || 1);
          this.installmentValue.textContent = formatMoneyFromCents(
            productTotal * fixedInterestFactor / fixedInstallments,
            currency
          );
        }

        return;
      }

      var quote = getQuote();
      var quoteState = quote ? getQuoteCartState(quote, cart) : 'invalid';

      if (quote && quoteState === 'invalid') {
        clearQuote();
        quote = null;
      }

      var rate = quoteState === 'applied' && quote && quote.selectedRate;
      var shippingCents = rate
        ? Math.max(0, Number(rate.priceCents != null ? rate.priceCents : Math.round(parsePrice(rate.price) * 100)) || 0)
        : 0;
      var total = productTotal + shippingCents;

      if (this.productsValue) this.productsValue.textContent = formatMoneyFromCents(productTotal, currency);
      if (this.totalValue) this.totalValue.textContent = formatMoneyFromCents(total, currency);

      if (this.shippingRow) {
        this.shippingRow.hidden = !rate;
        this.shippingRow.classList.toggle('is-free', Boolean(rate) && shippingCents === 0);
      }

      if (rate) {
        if (this.shippingValue) {
          this.shippingValue.textContent = shippingCents === 0 ? 'Grátis' : formatMoneyFromCents(shippingCents, currency);
        }

        if (this.shippingDetail) {
          this.shippingDetail.textContent =
            rate.name + (quote.postalCode ? ' · ' + formatPostalCode(quote.postalCode) : '');
        }
      }

      if (this.installmentValue) {
        var installments = Math.max(1, Number(this.dataset.installments) || 1);
        var interestFactor = Math.max(0, Number(this.dataset.interestFactor) || 1);
        this.installmentValue.textContent = formatMoneyFromCents(total * interestFactor / installments, currency);
      }
    }
  }

  class OrliCartShippingQuote extends HTMLElement {
    connectedCallback() {
      if (this._connected) return;
      this._connected = true;
      this.onQuoteChange = this.render.bind(this);
      this.onClick = this.handleClick.bind(this);
      document.addEventListener('orli:shipping-quote:updated', this.onQuoteChange);
      document.addEventListener('orli:shipping-quote:cleared', this.onQuoteChange);
      this.addEventListener('click', this.onClick);
      this.render();
    }

    disconnectedCallback() {
      document.removeEventListener('orli:shipping-quote:updated', this.onQuoteChange);
      document.removeEventListener('orli:shipping-quote:cleared', this.onQuoteChange);
      this.removeEventListener('click', this.onClick);
      window.clearTimeout(this.expirationTimer);
      this._connected = false;
    }

    handleClick(event) {
      if (!event.target.closest('[data-orli-shipping-quote-reset]')) return;
      event.preventDefault();
      clearQuote();
    }

    render() {
      window.clearTimeout(this.expirationTimer);

      var quote = getQuote();
      var rate = quote && quote.selectedRate;

      if (!quote || !rate) {
        this.hidden = true;
        this.innerHTML = '';
        return;
      }

      var deadline = rate.deadline
        ? '<span class="orli-cart-shipping-quote__deadline">' + escapeHTML(rate.deadline) + '</span>'
        : '';

      this.hidden = false;
      this.innerHTML =
        '<div class="orli-cart-shipping-quote__top">' +
        '<span>Frete estimado para ' +
        escapeHTML(formatPostalCode(quote.postalCode)) +
        '</span>' +
        '<button class="orli-cart-shipping-quote__reset" type="button" data-orli-shipping-quote-reset>Alterar CEP</button>' +
        '</div>' +
        '<div class="orli-cart-shipping-quote__rate">' +
        '<span class="orli-cart-shipping-quote__service">' +
        escapeHTML(rate.name) +
        deadline +
        '</span>' +
        '<strong class="orli-cart-shipping-quote__price">' +
        escapeHTML(rate.priceLabel) +
        '</strong>' +
        '</div>' +
        '<p class="orli-cart-shipping-quote__notice">Estimativa informativa. O prazo e o valor finais serão confirmados no checkout.</p>';

      var maxAge = Number(quote.maxAge || DEFAULT_QUOTE_MAX_AGE);
      var remainingTime = Number(quote.savedAt) + maxAge - Date.now();
      if (remainingTime > 0) {
        this.expirationTimer = window.setTimeout(this.render.bind(this), remainingTime + 50);
      }
    }
  }

  function updateCartQuantityButtons(container) {
    if (!container) return;

    var input = container.querySelector('[data-line-key]');
    var decreaseButton = container.querySelector('[data-orli-cart-quantity-action="decrease"]');
    var increaseButton = container.querySelector('[data-orli-cart-quantity-action="increase"]');
    var value = input ? Number(input.value) || 1 : 1;
    var maximum = input && input.max ? Number(input.max) : Number.POSITIVE_INFINITY;

    if (decreaseButton) decreaseButton.disabled = value <= 1;
    if (increaseButton) increaseButton.disabled = Number.isFinite(maximum) && value >= maximum;
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-orli-cart-quantity-action]');
    if (!button) return;

    var container = button.closest('.orli-cart-quantity');
    var input = container && container.querySelector('[data-line-key]');
    if (!input || button.disabled) return;

    var action = button.dataset.orliCartQuantityAction;
    var currentValue = Math.max(1, Number(input.value) || 1);
    var maximum = input.max ? Number(input.max) : Number.POSITIVE_INFINITY;
    var nextValue = action === 'increase' ? currentValue + 1 : currentValue - 1;

    nextValue = Math.max(1, Math.min(nextValue, maximum));
    if (nextValue === currentValue) return;

    input.value = String(nextValue);
    updateCartQuantityButtons(container);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('change', function (event) {
    if (!event.target.matches('.orli-cart-quantity [data-line-key]')) return;
    updateCartQuantityButtons(event.target.closest('.orli-cart-quantity'));
  });

  document.addEventListener('line-item:will-change', function (event) {
    var controls = event.target.querySelectorAll('.orli-cart-quantity__button');
    controls.forEach(function (button) {
      button.disabled = true;
    });
  });

  document.addEventListener('line-item:change', function (event) {
    updateCartQuantityButtons(event.target.querySelector('.orli-cart-quantity'));
  });

  function initializeCartQuantityButtons(root) {
    (root || document).querySelectorAll('.orli-cart-quantity').forEach(updateCartQuantityButtons);
  }

  if (SHIPPING_QUOTES_ENABLED && !window.customElements.get('orli-shipping-calculator')) {
    window.customElements.define('orli-shipping-calculator', OrliShippingCalculator);
  }

  if (!window.customElements.get('orli-free-shipping-notice')) {
    window.customElements.define('orli-free-shipping-notice', OrliFreeShippingNotice);
  }

  if (SHIPPING_QUOTES_ENABLED && !window.customElements.get('orli-cart-shipping-quote')) {
    window.customElements.define('orli-cart-shipping-quote', OrliCartShippingQuote);
  }

  if (!window.customElements.get('orli-cart-totals')) {
    window.customElements.define('orli-cart-totals', OrliCartTotals);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      if (SHIPPING_QUOTES_ENABLED) cleanupPendingShippingItems();
      initializeCartQuantityButtons(document);
    });
  } else {
    if (SHIPPING_QUOTES_ENABLED) cleanupPendingShippingItems();
    initializeCartQuantityButtons(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeCartQuantityButtons(event.target);
  });

  if (!SHIPPING_QUOTES_ENABLED) {
    removeStored(window.localStorage, QUOTE_STORAGE_KEY);
    removeStored(window.sessionStorage, PENDING_STORAGE_KEY);
  }

  window.OrliShippingQuote = {
    get: SHIPPING_QUOTES_ENABLED ? getQuote : function () { return null; },
    clear: clearQuote,
    cleanup: SHIPPING_QUOTES_ENABLED ? cleanupPendingShippingItems : function () { return Promise.resolve(); },
    getCartSignature: getCartSignature
  };
})();
